/* Generated by scripts/build-picker-icons.mjs. Do not edit directly. */
import type { PickerIconProps } from "../types.ts";

export function SymbolMedicalServicesIcon({
  size = 24,
  color = "currentColor",
  title,
  ...svgProps
}: PickerIconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      data-icon="symbol-medical-services"
      data-variant="filled"
      role={title ? "img" : undefined}
      aria-hidden={title ? undefined : true}
      focusable="false"
      {...svgProps}
    >
      {title ? <title>{title}</title> : null}
      <path d="M3.85 22.8Q2.75 22.8 1.98 22.02Q1.2 21.25 1.2 20.15L1.2 8.2Q1.2 7.1 1.98 6.33Q2.75 5.55 3.85 5.55L7.3 5.55L7.3 3.55Q7.3 2.45 8.07 1.68Q8.85 0.9 9.95 0.9L14.05 0.9Q15.15 0.9 15.93 1.68Q16.7 2.45 16.7 3.55L16.7 5.55L20.15 5.55Q21.25 5.55 22.02 6.33Q22.8 7.1 22.8 8.2L22.8 20.15Q22.8 21.25 22.02 22.02Q21.25 22.8 20.15 22.8ZM9.95 5.55L14.05 5.55L14.05 3.55Q14.05 3.55 14.05 3.55Q14.05 3.55 14.05 3.55L9.95 3.55Q9.95 3.55 9.95 3.55Q9.95 3.55 9.95 3.55ZM10.68 15.5L10.68 17.18Q10.68 17.73 11.06 18.11Q11.45 18.5 12 18.5Q12.55 18.5 12.94 18.11Q13.32 17.73 13.32 17.18L13.32 15.5L15 15.5Q15.55 15.5 15.94 15.11Q16.32 14.72 16.32 14.18Q16.32 13.63 15.94 13.24Q15.55 12.85 15 12.85L13.32 12.85L13.32 11.18Q13.32 10.63 12.94 10.24Q12.55 9.85 12 9.85Q11.45 9.85 11.06 10.24Q10.68 10.63 10.68 11.18L10.68 12.85L9 12.85Q8.45 12.85 8.06 13.24Q7.67 13.63 7.67 14.18Q7.67 14.72 8.06 15.11Q8.45 15.5 9 15.5Z" fill={color} />
    </svg>
  );
}
